const defaultAccess = [
  'Chief',
  'Admin',
  'Viewer',
  'CompressionChief',
  'CompressionAdmin',
  'CompressionViewer',
  'Compression',
  'CompressionSupervisor',
];
export const compressionAccionesRoles = {
  sharedActions: {
    scheduling: [...defaultAccess, 'CompressionLeader'],
    batches: [...defaultAccess, 'CompressionLeader'],
    schedulerV2: ['CompressionOperator', 'Admin', 'QualityControl'],
    qualityControl: [
      'Admin',
      'Chief',
      'Viewer',
      'QualityControl',
      'QualityControlInspector',
      'CompressionQC',
      'CompressionSupervisor',
      'CompressionLeader',
      'CompressionChief',
      'CompressionAdmin',
      'CompressionViewer',
    ],
    validation: [...defaultAccess, 'CompressionLeader'],
    packingBox: ['Admin', 'Chief', 'CompressionLabelOperator', 'LabelOperator'],
    packaging: [
      'Admin',
      'QualityControl',
      'CompressionQC',
      'CompressionSupervisor',
      'CompressionLeader',
    ],
    molds: [...defaultAccess, 'CompressionLeader'],
    qcData: ['Admin', 'Chief', 'Viewer', 'QualityControl'],
    performanceReport: [...defaultAccess, 'CompressionLeader'],
    efficiency: [
      'Chief',
      'Admin',
      'CompressionAdmin',
      'CompressionChief',
      'CompressionSupervisor',
      'StandardsAdmin',
      'CompressionEngineer',
      'CompressionStandardsAdmin',
    ],
    cobot: [...defaultAccess, 'CompressionCobot', 'RubberCobot'],
  },

  routerActions: {
    machine: defaultAccess,
    maintenance: defaultAccess,
  },

  sideNavActions: {
    main: [
      'Chief',
      'Admin',
      'Viewer',
      'CompressionChief',
      'CompressionAdmin',
      'CompressionViewer',
      'CompressionSupervisor',
      'Compression',
      'CompressionLeader',
      'CompressionScheduler',
      'QualityControl',
      'QualityControlInspector',
      'CompressionQc',
      'CompressionLabelOperator',
      'CompressionOperator',
      'CompressionEngineer',
      'CompressionStandardsAdmin',
      'StandardsAdmin',
    ],
  },
};
